import { Link } from "react-router-dom";
export default function NotFound() {
  return (
    <main className="min-h-[70vh] bg-gradient-to-b from-white to-[#f6f3f2] px-6 pb-20 pt-32">
      <section className="mx-auto max-w-3xl rounded-3xl border border-gray-200 bg-white p-8 text-center shadow-sm sm:p-12">
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-red-700">Fehler 404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-950 sm:text-5xl">Diese Seite wurde nicht gefunden</h1>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-8 text-gray-600">Die Adresse ist möglicherweise veraltet oder fehlerhaft. Über die Startseite gelangen Sie zu allen Informationen und zum GeoReport.</p>
        <Link to="/" className="mt-8 inline-flex rounded-full bg-red-700 px-6 py-3 font-semibold text-white transition hover:bg-red-800">Zur Startseite</Link>
      </section>
    </main>
  );
}
